module.exports = __webpack_public_path__ + "static/img/member-bg.aa93afa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member-bg.png
// module id = GHug
// module chunks = 126